import type { SxProps, Theme } from "@mui/material/styles";

export function mergeSx(
	internalSx?: SxProps<Theme>,
	externalSx?: SxProps<Theme>
): SxProps<Theme> {
	return [
		...(Array.isArray(internalSx)
			? internalSx
			: internalSx
			? [internalSx]
			: []),
		...(Array.isArray(externalSx)
			? externalSx
			: externalSx
			? [externalSx]
			: []),
	];
}
